"use strict";

exports.__esModule = true;
exports.EditableStripeChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Time = require("../../Time");
var _StripeChartElement = require("./StripeChartElement");
var _dec, _class, _EditableStripeChartElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a stripe chart for a particular device.
 */
var EditableStripeChartElement = exports.EditableStripeChartElement = (_dec = _Time.ReportingPeriodContext.withContext, _dec(_class = (_EditableStripeChartElement = /*#__PURE__*/function (_Component) {
  function EditableStripeChartElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(EditableStripeChartElement, _Component);
  var _proto = EditableStripeChartElement.prototype;
  _proto.render = function render() {
    var reportingPeriod = this.props.reportingPeriod;

    // Force set the brush to be a small portion in the middle for initial selection
    return /*#__PURE__*/_react["default"].createElement(_StripeChartElement.StripeChartElement, _extends({
      initialBrushInterval: getMiddleOfInterval(reportingPeriod.interval)
    }, this.props));
  };
  return EditableStripeChartElement;
}(_react.Component), _EditableStripeChartElement.defaultProps = {
  reportingPeriod: undefined
}, _EditableStripeChartElement)) || _class);
/**
 * Create an interval from the middle of the original on as a percentage size of the original
 */
function getMiddleOfInterval(interval, percentage) {
  if (percentage === void 0) {
    percentage = 10;
  }
  var duration = interval.endMillis - interval.startMillis;
  var targetDuration = duration / 100 * percentage;
  var middle = interval.startMillis + duration / 2;
  return {
    startMillis: middle - targetDuration / 2,
    endMillis: middle + targetDuration / 2
  };
}